import util from 'util';
import { CONSTANT } from '@const';
import { NotificationType, ReadNotificationPayload } from '@types';
import { getCurrentDateTime } from '@utils';
import { compareDesc } from 'date-fns';

import { ApiParams, ApiService } from '../api/ApiService';

export class NotificationService extends ApiService {
	static async getNotifications(): Promise<NotificationType[]> {
		const params: ApiParams = {
			method: 'GET',
			url: CONSTANT.NOTIFICATIONS_API_URL,
		};
		return await this.executeApiRequest(params).then((data: NotificationType[]) =>
			data.sort((a, b) => {
				return compareDesc(new Date(a.published), new Date(b.published));
			}),
		);
	}

	static async markAsRead(notificationId: string) {
		const payload: ReadNotificationPayload = {
			action: 'READ',
			auditDate: getCurrentDateTime(),
		};
		const params: ApiParams = {
			method: 'POST',
			url: util.format(CONSTANT.NOTIFICATION_API_URL, notificationId),
			data: payload,
		};
		return await this.executeApiRequest(params);
	}
}
